<div class="container-fluid login-container p-0 m-0" [@routerTransition]>
	<div class="d-flex p-0 m-0">
		<div class="full-height left-content" [ngClass]="{'center-login-content-popup': isPopup == true}">
			<span class="text-center" style='font-size: 18px;font-family: "Open Sans", sans-serif
				!important;font-weight: 500;' *ngIf="isPopup">Please log in to access premium features</span>
			<div class="center-content" [ngStyle]="{'height': isPopup ? 'auto' : '95vh'}">
				<a *ngIf="!isPopup" [ngStyle]="{ 'margin-top': isLoginWithEmail ? '120px' : '200px' }" [routerLink]="['/']"><img src="assets/cablepro/img/logo.png" width="182" height="31"
						alt="" class="logo" /></a>
				<div class="w-100 mt-5" style="flex: 1;" *ngIf="!isLoginWithEmail">
					<div class="btn-group-vertical">
						<button type="button" class="btn btn-custom" (click)="isLoginWithEmail=true">
							<div>
								<img width="24" height="24" src="assets/cablepro/img/email.svg" loading="lazy"
									alt="Email logo"><span> Log in with
									Email</span>
							</div>
						</button>
						<button type="button" class="btn btn-custom" (click)="signInWithGoogle()"
							[disabled]="!authLibraryReady">
							<div><img width="24" height="24" src="assets/cablepro/img/google.svg" loading="lazy"
									alt="Google logo">
								<span> Log in with Google</span>
							</div>
						</button>
						<!-- <button type="button" class="btn btn-custom" (click)="signInWithFacebook()"
							[disabled]="!authLibraryReady">
							<div><img width="24" height="24" src="assets/cablepro/img/facebook.svg" loading="lazy"
									alt="Facebook logo">
								<span> Log in with Facebook</span>
							</div>
						</button> -->
					</div>
					<div class="additional-buttons">
						<span>Not a customer?</span>
						<button type="button" class="btn btn-inline btn-blue btn-custom" (click)="tryForFree()">Get for Free</button>
					</div>
				</div>
				<div class="w-100 login-controls mt-5" style="flex: 1;"
					*ngIf="isLoginWithEmail && !isPasswordlessCodeSent">
					<div class="d-flex align-items-center">
						<a class="login-with-email" href="javascript:void(0);" (click)="isLoginWithEmail=false"><img
								src="assets/cablepro/img/back.png" alt="" />
						</a> <span class="login-with-email-span">Log in with
							email</span>
					</div>
					<form id="login-form" #loginForm="ngForm" class="m-login__form m-form login-form mt-2" method="post"
						novalidate (ngSubmit)="login(loginForm)">
						<div class="control margin-top-20">
							<input #userNameOrEmailAddressInput="ngModel" [(ngModel)]="username" autoFocus
								class="form-input" type="text" autocomplete="off"
								placeholder="{{l('UserNameOrEmail')}} *" name="userNameOrEmailAddress" required />
							<validation-messages [formCtrl]="userNameOrEmailAddressInput"></validation-messages>
						</div>
						<div class="control">
							<input #passwordInput="ngModel" [(ngModel)]="password" class="form-input" type="password"
								autocomplete="new-new-password" placeholder="{{l('Password')}} *" name="password"
								required maxlength="32" />
							<validation-messages *ngIf="isLoginClicked"
								[formCtrl]="passwordInput"></validation-messages>
							<a href="javascript:void(0);" (click)="forgotPassword()" id="forget-password"
								class="smalltext float-right forgot-password">{{l("ForgotPassword")}}</a>
						</div>
						<div class="control">
							<input type="checkbox" class="checkboxstyle" name="remember" value="Remember"
								[(ngModel)]="loginService.rememberMe">
							<label for="checkbox" class="text">Keep me logged
								in</label>
						</div>
						<div class="w-100">
							<button type="submit" class="btn btn-custom btn-blue" [disabled]="submitting">Log
								in</button>
						</div>
						<div class="text-center">
							<a href="javascript:void(0);" (click)="tryForFree()" id="forget-password"
								class="smalltext text-center signup-link">Not
								a member? Sign
								up</a>
						</div>
						<div class="signin-other-title">
							<h5 class="fs-13 title">OR</h5>
						</div>
						<div class="w-100">
							<button type="button" [disabled]="submitting" (click)="sendPasswordlessLoginCodeInput(true)"
								class="btn btn-custom">Log in with a code</button>
						</div>
						<div class="control text-center">
							<label class="passwordless-text">Go passwordless. We'll send you an email.</label>
						</div>
					</form>
				</div>
				<div class="w-100 login-controls mt-5" style="flex: 1;" *ngIf="isPasswordlessCodeSent">
					<div class="d-flex align-items-center">
						<a class="login-with-email" href="javascript:void(0);"
							(click)="isPasswordlessCodeSent=false"><img src="assets/cablepro/img/back.png" alt="" />
						</a> <span class="login-with-email-span">Finish logging in</span>
					</div>
					<form id="login-form" #loginForm="ngForm" class="m-login__form m-form login-form mt-2" method="post"
						novalidate>
						<div class="control passwordless-section">
							<ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
								[config]="{length:6,allowNumbersOnly:true,isPasswordInput:false}"></ng-otp-input>
							<div class="has-danger" *ngIf="passwordLessCodeInvalid">
								<div>
									<div class="form-control-feedback">
										{{l("ThisFieldIsRequired")}}
									</div>
								</div>
							</div>
						</div>

						<div class="control">
							<input type="checkbox" class="checkboxstyle" name="remember" value="Remember"
								[(ngModel)]="loginService.rememberMe">
							<label for="checkbox" class="text">Keep me logged
								in</label>
						</div>
						<div class="w-100">
							<button type="submit" class="btn btn-custom btn-blue" [disabled]="submitting"
								(click)="verifyPasswordlessLogin()">Log in</button>
						</div>

						<div class="control">
							<p class="smalltext text-center resend-code-text" *ngIf="!(canResend && countdown <= 0)">
								Please check your email. Resend in
								{{countdown}} seconds</p>
							<p class="smalltext text-center resend-code-text" *ngIf="canResend && countdown <= 0">Please
								check your email. <a href="javascript:void(0);" class="smalltext resend-code-link"
									(click)="sendPasswordlessLoginCodeInput()">Resend code</a></p>
						</div>
					</form>
				</div>
				<div class="text-center footer-area" *ngIf="!isPopup">
					<div class="footer-text">Software from <a href="https://elek.com" class="default-color"
							target="_blank">elek.com</a>
						<div class="ml-3 terms-privacy"><a class="cplp_f-legal m-2" href="https://elek.com/privacy"
								target="_blank">Privacy Policy</a> | <a class="cplp_f-legal m-2"
								href="https://elek.com/terms" target="_blank">Terms of Use</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right-content align-items-center justify-content-center full-height right-text-only text-center"
			*ngIf="!isPopup && (!isLoginWithEmail || (isLoginWithEmail && !isMobile))">
			<div>
				<div class="other-text-content">
					<h2 class="header">Electrical calculations and design software for professionals.</h2>
					<p class="line-text-20">Welcome to the #1 cloud electrical software platform.</p>
					<p class="line-text-18 support-number">Need support? Call us at <a href="tel:{{phoneNumber}}">
							{{phoneNumber}}</a></p>
				</div>
				<div class="image-box-container d-md-flex" #imageBoxContent>
					<div class="image-box">
						<a href="https://elek.com/events/" target="_blank"><img
								src="assets/cablepro/img/TrainingCourses.png" alt="Image 4"></a>
						<div class="image-box-content">
							<div class="title"><a href="https://elek.com/events/" target="_blank">Training Courses</a>
							</div>
							<div class="description">Join our live training courses to master the technical aspects of
								your software with expert guidance.</div>
						</div>
					</div>
					<div class="image-box">
						<a href="https://elek.com/tutorials/cable-pro-web/" target="_blank"><img
								src="assets/cablepro/img/TutorialVideos.png" alt="Image 2"></a>
						<div class="image-box-content">
							<div class="title"><a href="https://elek.com/tutorials/cable-pro-web/"
									target="_blank">Tutorial Videos</a></div>
							<div class="description">Watch our tutorials to learn how to use the software effectively.
								Get the most out of your tools with visual guides.</div>
						</div>
					</div>
					<div class="image-box">
						<a href="https://elek.com/electrical-software/" target="_blank"><img
								src="assets/cablepro/img/SoftwarePackages.png" alt="Image 1"></a>
						<div class="image-box-content">
							<div class="title"><a href="https://elek.com/electrical-software/" target="_blank">Software
									Packages</a></div>
							<div class="description">Explore our additional software packages to elevate your electrical
								engineering projects and optimize design processes.</div>
						</div>
					</div>
					<div class="image-box">
						<a href="https://elek.com/articles/" target="_blank"><img
								src="assets/cablepro/img/TechnicalArticles.png" alt="Image 3"></a>
						<div class="image-box-content">
							<div class="title"><a href=" https://elek.com/articles/" target="_blank">Technical
									Articles</a></div>
							<div class="description">Access technical articles for in-depth reference and insights. Stay
								informed with the latest tips and industry standards.</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>